// src/db/schema.js

export const DATABASE_TABLES = {
  USERS: 'users',
  PERFORMANCES: 'performances',
  STUDENT_RESPONSES: 'student_responses',
  ASSESSMENTS: 'assessments',
  ASSESSMENT_SETTINGS: 'assessment_settings'
};

export const USER_ROLES = {
  ADMIN: 'admin',
  TEACHER: 'teacher'
};

export const TABLE_SCHEMAS = {
    users: {
      id: 'INTEGER PRIMARY KEY AUTOINCREMENT',
      name: 'TEXT NOT NULL',
      email: 'TEXT UNIQUE NOT NULL',
      pin_code: 'TEXT NOT NULL',
      access_code: 'TEXT NOT NULL',
      role: 'TEXT NOT NULL',
      date_assigned: 'DATETIME DEFAULT CURRENT_TIMESTAMP',
      validity_days: 'INTEGER DEFAULT 300',
      is_enabled: 'BOOLEAN DEFAULT 1',
      restrict_time: 'BOOLEAN DEFAULT 0',
      access_start_time: 'TEXT DEFAULT "07:00"', 
      access_end_time: 'TEXT DEFAULT "15:00"',   
      restrict_days: 'BOOLEAN DEFAULT 1',        
      days_allowed: 'TEXT DEFAULT "1,2,3,4,5"',   
      maxSubUsers: 'INTEGER DEFAULT 5'
    },
  performances: {
    id: 'INTEGER PRIMARY KEY AUTOINCREMENT',
    student_name: 'TEXT NOT NULL',
    assessment_type: 'TEXT NOT NULL',
    assessment_kind: 'TEXT NOT NULL DEFAULT "gradeLevel"',  
    grade_level: 'TEXT NOT NULL',
    actual_grade_level: 'TEXT NOT NULL',
    grade_performance: 'TEXT NOT NULL',
    code_used: 'TEXT NOT NULL',
    test_date: 'DATE NOT NULL',
    test_time: 'TIME NOT NULL',
    isComplete: 'BOOLEAN DEFAULT 0'
  },
  assessments: {
    id: 'TEXT PRIMARY KEY',
    name: 'TEXT NOT NULL',
    fileName: 'TEXT NOT NULL',
    assessmentKind: 'TEXT NOT NULL DEFAULT "gradeLevel"',
    created_at: 'DATETIME DEFAULT CURRENT_TIMESTAMP'
  },
  assessment_settings: {
    id: 'INTEGER PRIMARY KEY AUTOINCREMENT',
    user_id: 'INTEGER NOT NULL',
    assessment_type: 'TEXT NOT NULL',
    access_code: 'TEXT NOT NULL',  
    is_visible: 'BOOLEAN DEFAULT 1',
    created_at: 'DATETIME DEFAULT CURRENT_TIMESTAMP',
    FOREIGN_KEY: '(user_id) REFERENCES users(id) ON DELETE CASCADE',
    UNIQUE: '(user_id, assessment_type)'
  }
};

export const ASSESSMENT_TYPES = {
  READING: 'reading',
  CALCULATION: 'calculation',
  PROBLEM_SOLVING: 'problem-solving'
};

export const ASSESSMENT_KINDS = {
  REGULAR: 'regular',
  GRADE_LEVEL: 'gradeLevel'
};

export const ASSESSMENT_STATES = {
  VISIBLE: 1,
  HIDDEN: 0
};

export const PERFORMANCE_STATUS = {
  COMPLETE: true,
  INCOMPLETE: false
};

export const TABLE_INDEXES = {
  users: [
    'CREATE INDEX IF NOT EXISTS idx_users_email_pin ON users(email, pin_code)',
    'CREATE INDEX IF NOT EXISTS idx_users_access_code ON users(access_code)'
  ],
  performances: [
    'CREATE INDEX IF NOT EXISTS idx_performances_code ON performances(code_used)',
    'CREATE INDEX IF NOT EXISTS idx_performances_date ON performances(test_date)',
    'CREATE INDEX IF NOT EXISTS idx_performances_type_kind ON performances(assessment_type, assessment_kind)'  // New index
  ],
  assessment_settings: [
    'CREATE INDEX IF NOT EXISTS idx_assessment_settings_user ON assessment_settings(user_id)',
    'CREATE INDEX IF NOT EXISTS idx_assessment_settings_type ON assessment_settings(assessment_type)',
    'CREATE INDEX IF NOT EXISTS idx_assessment_settings_access ON assessment_settings(access_code)'  // New index
  ]
};

export const VALIDATION_RULES = {
    users: {
      pin_code: {
        pattern: /^\d{4,6}$/,
        message: 'PIN code must be 4-6 digits'
      },
      email: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Invalid email format'
      },
      access_code: {
        pattern: /^[A-Za-z0-9]{4,8}$/,
        message: 'Access code must be 4-8 alphanumeric characters'
      },
      validity_days: {
        min: 1,
        message: 'Validity must be at least 1 day'
      }
    },
  assessments: {
    id: {
      pattern: /^[a-z0-9-]+$/,
      message: 'Assessment ID must contain only lowercase letters, numbers, and hyphens'
    },
    fileName: {
      pattern: /^[a-zA-Z0-9_-]+\.json$/,
      message: 'File name must be a valid JSON file name'
    },
    assessmentKind: {
      values: ['regular', 'gradeLevel'],
      message: 'Assessment kind must be either "regular" or "gradeLevel"'
    }
  },
  performances: {
    assessment_kind: {
      values: ['regular', 'gradeLevel'],
      message: 'Assessment kind must be either "regular" or "gradeLevel"'
    },
    grade_performance: {
      pattern: /^(([0-9]{1,3}%)|([A-Za-z\s]+))$/,
      message: 'Grade performance must be either a percentage or text description'
    }
  }
};

export const DEFAULT_VALUES = {
  assessmentKind: 'gradeLevel',
  isVisible: true,
  isComplete: false,
  validityDays: 300,
  isEnabled: true
};